// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ErrorDetails__container__iWWeF {
  font-size: 14px;
}
.ErrorDetails__container__iWWeF pre {
  margin-bottom: 12px;
}
.ErrorDetails__container__iWWeF pre:last-child {
  margin-bottom: 0;
}

.ErrorDetails__moreDetails__zAtyd {
  overflow: hidden;
}

.ErrorDetails__detailedInfo__o3bXU {
  background-color: #f1f1f1;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding: 12px;
  white-space: pre-line;
}

.ErrorDetails__showMore__z8Xm4 {
  display: block;
  font-weight: bold;
  margin-bottom: 12px;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/shared/utils/ErrorDetails.scss","webpack://./node_modules/@cabonline/shared/styles/vars.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;AAGE;EACE,mBCyBK;AD1BT;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;AAHF;;AAMA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAHF","sourcesContent":["@import \"@cabonline/shared/styles/vars\";\n\n.container {\n  font-size: 14px;\n\n  pre {\n    margin-bottom: $gutter;\n  }\n\n  pre:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.moreDetails {\n  overflow: hidden;\n}\n\n.detailedInfo {\n  background-color: #f1f1f1;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n  padding: 12px;\n  white-space: pre-line;\n}\n\n.showMore {\n  display: block;\n  font-weight: bold;\n  margin-bottom: $gutter;\n  user-select: none;\n}\n","$color-dark-blue: #0070cc;\n$color-yellow: #fc0;\n$color-blue: #008dff;\n$color-green: #00ba1a;\n$color-red: #f50000;\n$color-gray: #b1b1b1;\n$color-orange: #f27a00;\n$color-content-background: #f4f4f4;\n$color-menu-background: #1b1b1b;\n$color-menu-button: #2b2b2b;\n$color-menu-group: #222;\n$color-menu-dark-background: black;\n$color-menu-gray-highlight: #373737;\n$color-hover-table: #f2f9ff;\n$color-card-border: #e8e8e8;\n$color-disabled: #f5f5f5;\n$color-border: #e4e4e4;\n$color-text: #545454;\n$color-light-grey: #e1e2e1;\n$color-gray-text: #747474;\n$color-row-hover: #f8f8f8;\n$color-row-selected: #dff5f8;\n$color-link: #0070cc;\n$color-link-hover: #0070cc;\n\n$color-primary: #008dff;\n$color-primary-hover: #0070cc;\n$color-primary-button: $color-yellow;\n$color-gray-text-v2: #747474;\n$color-dark-text: #000;\n\n$gutter: 12px;\n$big-gutter: 16px;\n$card-gutter: 24px;\n\n$bp-medium: 767px;\n\n$font-size-small: 14px;\n$base: 20px;\n\n$row-small-height: 48px;\n$row-x-padding: 20px;\n$row-y-padding: 20px;\n\n$bold: bold;\n$semi: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ErrorDetails__container__iWWeF`,
	"moreDetails": `ErrorDetails__moreDetails__zAtyd`,
	"detailedInfo": `ErrorDetails__detailedInfo__o3bXU`,
	"showMore": `ErrorDetails__showMore__z8Xm4`
};
export default ___CSS_LOADER_EXPORT___;
